import {styleRule, StyleSheet} from "../../../stem-core/src/ui/Style";

import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {UI} from "../../../stem-core/src/ui/UIBase";
import {merchantStyleRule} from "../Security";
import {iFrameState} from "../../services/IFrameState";
import {Messages} from "../../Messages";
import {PANEL_FOOTER_THEME} from "../../../blink-sdk/Constants";
import {authService} from "../../../client/connection/Services";
import {PanelLink} from "./Primitives";
import {startDashboardFlow} from "../flows/startFlow";


class LoginFooterStyle extends StyleSheet {
    @styleRule
    loginExistingUserMessageDefault = {
        ...this.themeProps.PAYWALL_MESSAGE_STYLE,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE
    };

    @styleRule
    loginExistingUserMessageReversed = {
        ...this.themeProps.PAYWALL_MESSAGE_STYLE,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        color: this.themeProps.MERCHANT_TEXT_INVERT_PRIMARY,
    };

    @styleRule
    loginExistingUserLinkDefault = {
        ...this.themeProps.AUTH_LINK_STYLE,
        fontSize: "inherit",
        whiteSpace: "nowrap",
    };

    @styleRule
    loginExistingUserLinkReversed = {
        ...this.themeProps.AUTH_LINK_STYLE,
        fontSize: "inherit",
        whiteSpace: "nowrap",
        color: this.themeProps.MERCHANT_TEXT_INVERT_PRIMARY,
        textDecoration: "underline",
    };

    @merchantStyleRule
    pgLoginMessageStyle = {
        ...iFrameState.loginMessageStyle,
    }
}

@registerStyle(LoginFooterStyle)
export class LoginFooter extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            controller: null,
            label: "",
            linkLabel: Messages.logIn,
            manageAccount: false, // TODO: Convince Mihai this should be true by default.
            manageAccountLabel: Messages.manageMyAccount,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.pgLoginMessageStyle + (iFrameState.footerTheme === PANEL_FOOTER_THEME.default
            ? this.styleSheet.loginExistingUserMessageDefault
            : this.styleSheet.loginExistingUserMessageReversed));
    }

    render() {
        const {styleSheet} = this;
        const {controller, label, linkLabel, anid, manageAccount, manageAccountLabel} = this.options;
        const linkClassName = iFrameState.footerTheme === PANEL_FOOTER_THEME.default
            ? styleSheet.loginExistingUserLinkDefault
            : styleSheet.loginExistingUserLinkReversed;

        if (authService.isAuthenticated()) {
            return manageAccount
                ? <PanelLink value={manageAccountLabel} onClick={ontroller.onManageAccountClick}
                             anid={anid} className={linkClassName}/>
                : null;
        }

        return [
            label || controller.getLoginFooterMessage(),
            <PanelLink value={linkLabel} onClick={(e) => controller.onLoginClick(e)} anid={anid}
                       className={linkClassName} />,
        ]
    }
}

export function PanelLoginFooterBuilder(ControllerClass) {
    return (options, children) => <LoginFooter controller={new ControllerClass()} {...options}>{children}</LoginFooter>;
}

@registerStyle(LoginFooterStyle)
export class PromptInlineUserDashboard extends PanelLink {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            label: Messages.manageMyAccount,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.pgLoginMessageStyle + (iFrameState.footerTheme === PANEL_FOOTER_THEME.default
            ? this.styleSheet.loginExistingUserMessageDefault
            : this.styleSheet.loginExistingUserMessageReversed));
        attr.addClass(iFrameState.footerTheme === PANEL_FOOTER_THEME.default
            ? this.styleSheet.loginExistingUserLinkDefault
            : this.styleSheet.loginExistingUserLinkReversed);
    }

    render() {
        return this.options.label;
    }

    onMount() {
        super.onMount();
        this.addClickListener(() => startDashboardFlow());
    }
}
